// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".masthead[data-v-b7de9f04]{display:flex;align-items:center;width:100%;justify-content:center}.masthead__logo[data-v-b7de9f04]{width:72%;padding-top:1.1rem;padding-bottom:.9rem}", ""]);
// Exports
module.exports = exports;
